<template>
    <el-tag :type="type">
        <el-icon v-if="loading" class="is-loading" style="margin-right: 4px; vertical-align: middle;">
            <Loading />
        </el-icon>
        {{ label }}
    </el-tag>
</template>

<script setup lang="ts">
import { HuonekorttiStatusResponse } from "@/api/models/huonekortti-status-response"
import HuonekorttiStatusEnum from "@/types/HuonekorttiStatusEnum"
import { Loading } from "@element-plus/icons-vue"
import { computed } from "vue"

const props = defineProps<{
    status: HuonekorttiStatusResponse
    loading?: boolean
}>()

const typeMap: Record<HuonekorttiStatusResponse, string> = {
    [HuonekorttiStatusResponse.Tyo]: "info",
    [HuonekorttiStatusResponse.Julkaistu]: "primary",
    [HuonekorttiStatusResponse.Odottaa]: "warning",
    [HuonekorttiStatusResponse.Hyvaksytty]: "success"
}

const labelMap: Record<HuonekorttiStatusResponse, string> = {
    [HuonekorttiStatusResponse.Tyo]: HuonekorttiStatusEnum.Tyo,
    [HuonekorttiStatusResponse.Julkaistu]: HuonekorttiStatusEnum.Julkaistu,
    [HuonekorttiStatusResponse.Odottaa]: HuonekorttiStatusEnum.Odottaa,
    [HuonekorttiStatusResponse.Hyvaksytty]: HuonekorttiStatusEnum.Hyvaksytty
}

const type = computed(() => typeMap[props.status] ?? "primary")
const label = computed(() => labelMap[props.status] ?? "")
</script>
